var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9B9B9B",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 13,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M18.5 18.5 24 24"
  }))));
};
export default SvgSearch;